import { useState, useEffect } from "react";
import styles from "./UpcomingLiveSession.module.css";
import { FiSearch } from "react-icons/fi";
import { ENDPOINTS } from "../../utils/endpoints";
import api from "../../services/api";
import SessionCard from "../../components/LiveSessionCard/SessionCard";
import useDashboardStore from "../../store/dashboardStore";
import CustomDatePicker from "../Calendar/CustomDatePicker";
import InstructorSelector from "../InstructorSelector/InstructorSelector";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const UpcomingLiveSessions = () => {
  const { communityIndex, communities, traders } = useDashboardStore();
  const [sessions, setSessions] = useState([]);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState(null);
  const [selectedInstructorId, setSelectedInstructorId] = useState(null);

  const handleDateChange = (date) => setDate(date);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const selectedCommunityId = communities[communityIndex].id;
        const { data } = await api.get(
          ENDPOINTS.GET_LIVE_SESSION_BY_COMMUNITY_ID(selectedCommunityId)
        );
        if (data.success) {
          setSessions(data.sessions);
        }
      } catch (err) {
        console.error("Failed to fetch sessions", err);
      }
    };

    fetchSessions();
  }, [communities, communityIndex]);

  function isSameUTCDate(date1, date2) {
    if (!date1 || !date2) return false;

    const d1 = dayjs(date1);
    const d2 = dayjs(date2);
    return d1.isSame(d2, "day");
  }

  const filteredSessions = sessions.filter((session) => {
    const titleMatch = session.session_title
      ?.toLowerCase()
      .includes(search.toLowerCase());

    const instructorMatch =
      selectedInstructorId == null ||
      session.instructor_id === selectedInstructorId;

    const dateMatch =
      !date ||
      !session.start_datetime ||
      isSameUTCDate(date, session.start_datetime);

    return titleMatch && instructorMatch && dateMatch;
  });

  const selectedDaySessions = sessions.filter((session) => {
    const dateMatch =
      !date ||
      !session.start_datetime ||
      isSameUTCDate(date, session.start_datetime);

    return dateMatch;
  });

  const filteredTraders = traders
    .filter((trader) =>
      selectedDaySessions.some((session) => session.instructor_id === trader.id)
    )
    .map((e) => ({ id: e.id, name: e.username, profile_pic: e.profile_pic }));

  return (
    <div className={styles.container}>
      <div className={styles.appBar}>
        <h2 className={styles.title}>Upcoming Live Sessions</h2>
        <div className={styles.searchContainer}>
          <input
            type="text"
            placeholder="Type in to search .."
            className={styles.searchInput}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <FiSearch className={styles.searchIcon} />
        </div>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.leftPanel}>
          <CustomDatePicker
            preSelectedDate={date}
            onDateSelect={handleDateChange}
          />
          {filteredTraders.length > 0 && (
            <InstructorSelector
              instructors={filteredTraders}
              selectedId={selectedInstructorId}
              onSelect={(id) => {
                if (id === selectedInstructorId) {
                  setSelectedInstructorId(null);
                } else {
                  setSelectedInstructorId(id);
                }
              }}
            />
          )}
        </div>
        <div className={styles.rightPanel}>
          <h2 className={styles.heading}>Selected Date Sessions</h2>
          {filteredSessions.map((session, i) => (
            <SessionCard key={i} session={session} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpcomingLiveSessions;
